import React from 'react';
import { iconBaseVariants, type IconBaseVariantProps } from './Icon.variants';

// SM icons
import { ReactComponent as SmAdd } from '../../../assets/icons/standard/sm/add.svg';
import { ReactComponent as SmAlert } from '../../../assets/icons/standard/sm/alert.svg';
import { ReactComponent as SmArrowsDown } from '../../../assets/icons/standard/sm/arrows-down.svg';
import { ReactComponent as SmArrowsRight } from '../../../assets/icons/standard/sm/arrows-right.svg';
import { ReactComponent as SmArrowsUp } from '../../../assets/icons/standard/sm/arrows-up.svg';
import { ReactComponent as SmArrowsVertical } from '../../../assets/icons/standard/sm/arrows-vertical.svg';
import { ReactComponent as SmBusinessUnit } from '../../../assets/icons/standard/sm/business-unit.svg';
import { ReactComponent as SmCalendar } from '../../../assets/icons/standard/sm/calendar.svg';
import { ReactComponent as SmCard } from '../../../assets/icons/standard/sm/card.svg';
import { ReactComponent as SmCheck } from '../../../assets/icons/standard/sm/check.svg';
import { ReactComponent as SmChevronDown } from '../../../assets/icons/standard/sm/chevron-down.svg';
import { ReactComponent as SmChevronLeft } from '../../../assets/icons/standard/sm/chevron-left.svg';
import { ReactComponent as SmChevronRight } from '../../../assets/icons/standard/sm/chevron-right.svg';
import { ReactComponent as SmChevronUp } from '../../../assets/icons/standard/sm/chevron-up.svg';
import { ReactComponent as SmClock } from '../../../assets/icons/standard/sm/clock.svg';
import { ReactComponent as SmClose } from '../../../assets/icons/standard/sm/close.svg';
import { ReactComponent as SmCompass } from '../../../assets/icons/standard/sm/compass.svg';
import { ReactComponent as SmDelete } from '../../../assets/icons/standard/sm/delete.svg';
import { ReactComponent as SmDesktopScreen } from '../../../assets/icons/standard/sm/desktop-screen.svg';
import { ReactComponent as SmDot } from '../../../assets/icons/standard/sm/dot.svg';
import { ReactComponent as SmEdit } from '../../../assets/icons/standard/sm/edit.svg';
import { ReactComponent as SmFilter } from '../../../assets/icons/standard/sm/filter.svg';
import { ReactComponent as SmHeadphones } from '../../../assets/icons/standard/sm/headphones.svg';
import { ReactComponent as SmId } from '../../../assets/icons/standard/sm/id.svg';
import { ReactComponent as SmImport } from '../../../assets/icons/standard/sm/import.svg';
import { ReactComponent as SmInProgress } from '../../../assets/icons/standard/sm/in-progress.svg';
import { ReactComponent as SmLanguage } from '../../../assets/icons/standard/sm/language.svg';
import { ReactComponent as SmLaptop } from '../../../assets/icons/standard/sm/laptop.svg';
import { ReactComponent as SmLocation } from '../../../assets/icons/standard/sm/location.svg';
import { ReactComponent as SmLock } from '../../../assets/icons/standard/sm/lock.svg';
import { ReactComponent as SmMail } from '../../../assets/icons/standard/sm/mail.svg';
import { ReactComponent as SmMicrophone } from '../../../assets/icons/standard/sm/microphone.svg';
import { ReactComponent as SmMinus } from '../../../assets/icons/standard/sm/minus.svg';
import { ReactComponent as SmMoreHorizontally } from '../../../assets/icons/standard/sm/more-horizontally.svg';
import { ReactComponent as SmMoreVertical } from '../../../assets/icons/standard/sm/more-vertical.svg';
import { ReactComponent as SmNewwindow } from '../../../assets/icons/standard/sm/newwindow.svg';
import { ReactComponent as SmNotStarted } from '../../../assets/icons/standard/sm/not-started.svg';
import { ReactComponent as SmOneSitting } from '../../../assets/icons/standard/sm/one-sitting.svg';
import { ReactComponent as SmPhone } from '../../../assets/icons/standard/sm/phone.svg';
import { ReactComponent as SmPlus } from '../../../assets/icons/standard/sm/plus.svg';
import { ReactComponent as SmQuiet } from '../../../assets/icons/standard/sm/quiet.svg';
import { ReactComponent as SmRatersInvited } from '../../../assets/icons/standard/sm/raters-invited.svg';
import { ReactComponent as SmRegenerate } from '../../../assets/icons/standard/sm/regenerate.svg';
import { ReactComponent as SmReorder } from '../../../assets/icons/standard/sm/reorder.svg';
import { ReactComponent as SmReplace } from '../../../assets/icons/standard/sm/replace.svg';
import { ReactComponent as SmResizer } from '../../../assets/icons/standard/sm/resizer.svg';
import { ReactComponent as SmResume } from '../../../assets/icons/standard/sm/resume.svg';
import { ReactComponent as SmSave } from '../../../assets/icons/standard/sm/save.svg';
import { ReactComponent as SmSearch } from '../../../assets/icons/standard/sm/search.svg';
import { ReactComponent as SmSettings } from '../../../assets/icons/standard/sm/settings.svg';
import { ReactComponent as SmStar } from '../../../assets/icons/standard/sm/star.svg';
import { ReactComponent as SmTargetFilledDown } from '../../../assets/icons/standard/sm/target-filled-down.svg';
import { ReactComponent as SmTriangleDown } from '../../../assets/icons/standard/sm/triangle-down.svg';
import { ReactComponent as SmTriangleFilledLeft } from '../../../assets/icons/standard/sm/triangle-filled-left.svg';
import { ReactComponent as SmTriangleFilledRight } from '../../../assets/icons/standard/sm/triangle-filled-right.svg';
import { ReactComponent as SmTriangleLeft } from '../../../assets/icons/standard/sm/triangle-left.svg';
import { ReactComponent as SmTriangleRight } from '../../../assets/icons/standard/sm/triangle-right.svg';
import { ReactComponent as SmUnassigned } from '../../../assets/icons/standard/sm/unassigned.svg';
import { ReactComponent as SmUnvisible } from '../../../assets/icons/standard/sm/unvisible.svg';
import { ReactComponent as SmUpload } from '../../../assets/icons/standard/sm/upload.svg';
import { ReactComponent as SmVideo } from '../../../assets/icons/standard/sm/video.svg';
import { ReactComponent as SmVisible } from '../../../assets/icons/standard/sm/visible.svg';
import { ReactComponent as SmZoom } from '../../../assets/icons/standard/sm/zoom.svg';

// MD icons
import { ReactComponent as MdAbout } from '../../../assets/icons/standard/md/about.svg';
import { ReactComponent as MdAdd } from '../../../assets/icons/standard/md/add.svg';
import { ReactComponent as MdAi } from '../../../assets/icons/standard/md/ai.svg';
import { ReactComponent as MdAlert } from '../../../assets/icons/standard/md/alert.svg';
import { ReactComponent as MdArrowDown } from '../../../assets/icons/standard/md/arrow-down.svg';
import { ReactComponent as MdArrowLeft } from '../../../assets/icons/standard/md/arrow-left.svg';
import { ReactComponent as MdArrowRight } from '../../../assets/icons/standard/md/arrow-right.svg';
import { ReactComponent as MdBurgermenu } from '../../../assets/icons/standard/md/burgermenu.svg';
import { ReactComponent as MdChevronDown } from '../../../assets/icons/standard/md/chevron-down.svg';
import { ReactComponent as MdChevronLeft } from '../../../assets/icons/standard/md/chevron-left.svg';
import { ReactComponent as MdChevronRight } from '../../../assets/icons/standard/md/chevron-right.svg';
import { ReactComponent as MdChevronUp } from '../../../assets/icons/standard/md/chevron-up.svg';
import { ReactComponent as MdCloseS } from '../../../assets/icons/standard/md/close-s.svg';
import { ReactComponent as MdClose } from '../../../assets/icons/standard/md/close.svg';
import { ReactComponent as MdCopy } from '../../../assets/icons/standard/md/copy.svg';
import { ReactComponent as MdEdit } from '../../../assets/icons/standard/md/edit.svg';
import { ReactComponent as MdError } from '../../../assets/icons/standard/md/error.svg';
import { ReactComponent as MdExportPdf } from '../../../assets/icons/standard/md/export-pdf.svg';
import { ReactComponent as MdGrow1 } from '../../../assets/icons/standard/md/grow-1.svg';
import { ReactComponent as MdGrow } from '../../../assets/icons/standard/md/grow.svg';
import { ReactComponent as MdImport } from '../../../assets/icons/standard/md/import.svg';
import { ReactComponent as MdInProgress2 } from '../../../assets/icons/standard/md/in-progress-2.svg';
import { ReactComponent as MdInProgress } from '../../../assets/icons/standard/md/in-progress.svg';
import { ReactComponent as MdInfo } from '../../../assets/icons/standard/md/info.svg';
import { ReactComponent as MdLanguage } from '../../../assets/icons/standard/md/language.svg';
import { ReactComponent as MdLink } from '../../../assets/icons/standard/md/link.svg';
import { ReactComponent as MdLink2 } from '../../../assets/icons/standard/md/link2.svg';
import { ReactComponent as MdLogOut } from '../../../assets/icons/standard/md/log-out.svg';
import { ReactComponent as MdMail } from '../../../assets/icons/standard/md/mail.svg';
import { ReactComponent as MdMinus } from '../../../assets/icons/standard/md/minus.svg';
import { ReactComponent as MdMyprofile } from '../../../assets/icons/standard/md/myprofile.svg';
import { ReactComponent as MdNewwindow } from '../../../assets/icons/standard/md/newwindow.svg';
import { ReactComponent as MdPhone } from '../../../assets/icons/standard/md/phone.svg';
import { ReactComponent as MdPlay } from '../../../assets/icons/standard/md/play.svg';
import { ReactComponent as MdPlusInCircle } from '../../../assets/icons/standard/md/plus-in-circle.svg';
import { ReactComponent as MdPlus } from '../../../assets/icons/standard/md/plus.svg';
import { ReactComponent as MdPublish } from '../../../assets/icons/standard/md/publish.svg';
import { ReactComponent as MdResumeIcon } from '../../../assets/icons/standard/md/resume-icon.svg';
import { ReactComponent as MdRevert } from '../../../assets/icons/standard/md/revert.svg';
import { ReactComponent as MdRight } from '../../../assets/icons/standard/md/right.svg';
import { ReactComponent as MdSeeCrossedOut } from '../../../assets/icons/standard/md/see-crossed-out.svg';
import { ReactComponent as MdSeeHeatmap } from '../../../assets/icons/standard/md/see-heatmap.svg';
import { ReactComponent as MdSee } from '../../../assets/icons/standard/md/see.svg';
import { ReactComponent as MdStar } from '../../../assets/icons/standard/md/star.svg';
import { ReactComponent as MdSuccess } from '../../../assets/icons/standard/md/success.svg';
import { ReactComponent as MdTeam } from '../../../assets/icons/standard/md/team.svg';
import { ReactComponent as MdTrash } from '../../../assets/icons/standard/md/trash.svg';
import { ReactComponent as MdWatch } from '../../../assets/icons/standard/md/watch.svg';

// LG icons
import { ReactComponent as LgAssessments } from '../../../assets/icons/standard/lg/assessments.svg';
import { ReactComponent as LgAttention } from '../../../assets/icons/standard/lg/attention.svg';
import { ReactComponent as LgBio } from '../../../assets/icons/standard/lg/bio.svg';
import { ReactComponent as LgBusinessUnit } from '../../../assets/icons/standard/lg/business-unit.svg';
import { ReactComponent as LgCalendar } from '../../../assets/icons/standard/lg/calendar.svg';
import { ReactComponent as LgChain } from '../../../assets/icons/standard/lg/chain.svg';
import { ReactComponent as LgChart } from '../../../assets/icons/standard/lg/chart.svg';
import { ReactComponent as LgCheck } from '../../../assets/icons/standard/lg/check.svg';
import { ReactComponent as LgChecklist } from '../../../assets/icons/standard/lg/checklist.svg';
import { ReactComponent as LgClock } from '../../../assets/icons/standard/lg/clock.svg';
import { ReactComponent as LgCoaches } from '../../../assets/icons/standard/lg/coaches.svg';
import { ReactComponent as LgCommunication } from '../../../assets/icons/standard/lg/communication.svg';
import { ReactComponent as LgCompany } from '../../../assets/icons/standard/lg/company.svg';
import { ReactComponent as LgContact } from '../../../assets/icons/standard/lg/contact.svg';
import { ReactComponent as LgDatabase } from '../../../assets/icons/standard/lg/database.svg';
import { ReactComponent as LgDate } from '../../../assets/icons/standard/lg/date.svg';
import { ReactComponent as LgEmptyDrawer } from '../../../assets/icons/standard/lg/empty-drawer.svg';
import { ReactComponent as LgExperience } from '../../../assets/icons/standard/lg/experience.svg';
import { ReactComponent as LgExplore } from '../../../assets/icons/standard/lg/explore.svg';
import { ReactComponent as LgGoodFit } from '../../../assets/icons/standard/lg/good-fit.svg';
import { ReactComponent as LgHelp } from '../../../assets/icons/standard/lg/help.svg';
import { ReactComponent as LgInterested } from '../../../assets/icons/standard/lg/interested.svg';
import { ReactComponent as LgIntroductorySessions } from '../../../assets/icons/standard/lg/introductory-sessions.svg';
import { ReactComponent as LgInviteRaters } from '../../../assets/icons/standard/lg/invite-raters.svg';
import { ReactComponent as LgJobTitle } from '../../../assets/icons/standard/lg/job-title.svg';
import { ReactComponent as LgLocation } from '../../../assets/icons/standard/lg/location.svg';
import { ReactComponent as LgLock } from '../../../assets/icons/standard/lg/lock.svg';
import { ReactComponent as LgMegaphone } from '../../../assets/icons/standard/lg/megaphone.svg';
import { ReactComponent as LgMobile } from '../../../assets/icons/standard/lg/mobile.svg';
import { ReactComponent as LgNotification } from '../../../assets/icons/standard/lg/notification.svg';
import { ReactComponent as LgProgress } from '../../../assets/icons/standard/lg/progress.svg';
import { ReactComponent as LgQualification } from '../../../assets/icons/standard/lg/qualification.svg';
import { ReactComponent as LgResume } from '../../../assets/icons/standard/lg/resume.svg';
import { ReactComponent as LgSearchCoaches } from '../../../assets/icons/standard/lg/search-coaches.svg';
import { ReactComponent as LgSecureData } from '../../../assets/icons/standard/lg/secure-data.svg';
import { ReactComponent as LgSecureTraining } from '../../../assets/icons/standard/lg/secure-training.svg';
import { ReactComponent as LgSecureTransmission } from '../../../assets/icons/standard/lg/secure-transmission.svg';
import { ReactComponent as LgSecure } from '../../../assets/icons/standard/lg/secure.svg';
import { ReactComponent as LgSerachDatabase } from '../../../assets/icons/standard/lg/serach-database.svg';
import { ReactComponent as LgStrategy } from '../../../assets/icons/standard/lg/strategy.svg';
import { ReactComponent as LgVideo } from '../../../assets/icons/standard/lg/video.svg';

/*
 * Static imports for CRA compatibility (import.meta.glob is Vite-only).
 * Uses ReactComponent imports for SVGs which CRA supports via SVGR.
 */
type SvgComponent = React.FC<React.SVGProps<SVGSVGElement>>;
type Registry = Record<string, SvgComponent>;

const registry: Record<'sm' | 'md' | 'lg', Registry> = {
  sm: {
    'add': SmAdd,
    'alert': SmAlert,
    'arrows-down': SmArrowsDown,
    'arrows-right': SmArrowsRight,
    'arrows-up': SmArrowsUp,
    'arrows-vertical': SmArrowsVertical,
    'business-unit': SmBusinessUnit,
    'calendar': SmCalendar,
    'card': SmCard,
    'check': SmCheck,
    'chevron-down': SmChevronDown,
    'chevron-left': SmChevronLeft,
    'chevron-right': SmChevronRight,
    'chevron-up': SmChevronUp,
    'clock': SmClock,
    'close': SmClose,
    'compass': SmCompass,
    'delete': SmDelete,
    'desktop-screen': SmDesktopScreen,
    'dot': SmDot,
    'edit': SmEdit,
    'filter': SmFilter,
    'headphones': SmHeadphones,
    'id': SmId,
    'import': SmImport,
    'in-progress': SmInProgress,
    'language': SmLanguage,
    'laptop': SmLaptop,
    'location': SmLocation,
    'lock': SmLock,
    'mail': SmMail,
    'microphone': SmMicrophone,
    'minus': SmMinus,
    'more-horizontally': SmMoreHorizontally,
    'more-vertical': SmMoreVertical,
    'newwindow': SmNewwindow,
    'not-started': SmNotStarted,
    'one-sitting': SmOneSitting,
    'phone': SmPhone,
    'plus': SmPlus,
    'quiet': SmQuiet,
    'raters-invited': SmRatersInvited,
    'regenerate': SmRegenerate,
    'reorder': SmReorder,
    'replace': SmReplace,
    'resizer': SmResizer,
    'resume': SmResume,
    'save': SmSave,
    'search': SmSearch,
    'settings': SmSettings,
    'star': SmStar,
    'target-filled-down': SmTargetFilledDown,
    'triangle-down': SmTriangleDown,
    'triangle-filled-left': SmTriangleFilledLeft,
    'triangle-filled-right': SmTriangleFilledRight,
    'triangle-left': SmTriangleLeft,
    'triangle-right': SmTriangleRight,
    'unassigned': SmUnassigned,
    'unvisible': SmUnvisible,
    'upload': SmUpload,
    'video': SmVideo,
    'visible': SmVisible,
    'zoom': SmZoom,
  },
  md: {
    'about': MdAbout,
    'add': MdAdd,
    'ai': MdAi,
    'alert': MdAlert,
    'arrow-down': MdArrowDown,
    'arrow-left': MdArrowLeft,
    'arrow-right': MdArrowRight,
    'burgermenu': MdBurgermenu,
    'chevron-down': MdChevronDown,
    'chevron-left': MdChevronLeft,
    'chevron-right': MdChevronRight,
    'chevron-up': MdChevronUp,
    'close-s': MdCloseS,
    'close': MdClose,
    'copy': MdCopy,
    'edit': MdEdit,
    'error': MdError,
    'export-pdf': MdExportPdf,
    'grow-1': MdGrow1,
    'grow': MdGrow,
    'import': MdImport,
    'in-progress-2': MdInProgress2,
    'in-progress': MdInProgress,
    'info': MdInfo,
    'language': MdLanguage,
    'link': MdLink,
    'link2': MdLink2,
    'log-out': MdLogOut,
    'mail': MdMail,
    'minus': MdMinus,
    'myprofile': MdMyprofile,
    'newwindow': MdNewwindow,
    'phone': MdPhone,
    'play': MdPlay,
    'plus-in-circle': MdPlusInCircle,
    'plus': MdPlus,
    'publish': MdPublish,
    'resume-icon': MdResumeIcon,
    'revert': MdRevert,
    'right': MdRight,
    'see-crossed-out': MdSeeCrossedOut,
    'see-heatmap': MdSeeHeatmap,
    'see': MdSee,
    'star': MdStar,
    'success': MdSuccess,
    'team': MdTeam,
    'trash': MdTrash,
    'watch': MdWatch,
  },
  lg: {
    'assessments': LgAssessments,
    'attention': LgAttention,
    'bio': LgBio,
    'business-unit': LgBusinessUnit,
    'calendar': LgCalendar,
    'chain': LgChain,
    'chart': LgChart,
    'check': LgCheck,
    'checklist': LgChecklist,
    'clock': LgClock,
    'coaches': LgCoaches,
    'communication': LgCommunication,
    'company': LgCompany,
    'contact': LgContact,
    'database': LgDatabase,
    'date': LgDate,
    'empty-drawer': LgEmptyDrawer,
    'experience': LgExperience,
    'explore': LgExplore,
    'good-fit': LgGoodFit,
    'help': LgHelp,
    'interested': LgInterested,
    'introductory-sessions': LgIntroductorySessions,
    'invite-raters': LgInviteRaters,
    'job-title': LgJobTitle,
    'location': LgLocation,
    'lock': LgLock,
    'megaphone': LgMegaphone,
    'mobile': LgMobile,
    'notification': LgNotification,
    'progress': LgProgress,
    'qualification': LgQualification,
    'resume': LgResume,
    'search-coaches': LgSearchCoaches,
    'secure-data': LgSecureData,
    'secure-training': LgSecureTraining,
    'secure-transmission': LgSecureTransmission,
    'secure': LgSecure,
    'serach-database': LgSerachDatabase,
    'strategy': LgStrategy,
    'video': LgVideo,
  },
};

/** Names available in the standard icon registry across all sizes. */
export type StandardIconName = string;  // runtime registry; literal typing deferred until codegen

export interface StandardProps extends IconBaseVariantProps {
  /** Icon name as it appears in src/assets/icons/standard/<size>/<name>.svg */
  name: StandardIconName;
  /** Optional accessible name. When provided, wrapper renders role="img" + aria-label.
   *  When omitted, wrapper is aria-hidden (decorative). */
  title?: string;
  /** Optional className passthrough for sx-style overrides at instance level. */
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const Standard: React.FC<StandardProps> = ({ name, size, title, className }) => {
  const resolvedSize = size ?? 'md';
  const SvgComponent = registry[resolvedSize][name];

  if (!SvgComponent) {
    if (typeof console !== 'undefined') {
      console.warn(
        `[Icon.Standard] missing asset: standard/${resolvedSize}/${name}.svg — ` +
        `did you add the SVG import?`,
      );
    }
    // In dev, render a visible "?" placeholder so missing icons are obvious
    // during authoring rather than collapsing silently. Production still
    // returns null to avoid surfacing dev artifacts to end users.
    if (process.env.NODE_ENV !== 'production') {
      const wrapperClass = [iconBaseVariants({ size: resolvedSize }), className].filter(Boolean).join(' ');
      return (
        <span
          className={wrapperClass}
          role="img"
          aria-label={`missing icon: ${name}`}
          title={`Missing icon: ${name} (${resolvedSize})`}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px dashed #d33',
            color: '#d33',
            fontFamily: 'monospace',
            fontSize: '0.8em',
            lineHeight: 1,
            boxSizing: 'border-box',
          }}
        >
          ?
        </span>
      );
    }
    return null;
  }

  const wrapperClass = [iconBaseVariants({ size: resolvedSize }), className].filter(Boolean).join(' ');
  const a11y = title
    ? { role: 'img' as const, 'aria-label': title }
    : { 'aria-hidden': true as const };

  return (
    <span
      className={wrapperClass}
      {...a11y}
    >
      <SvgComponent />
    </span>
  );
};

Standard.displayName = 'Icon.Standard';